/** Where a definition's "Open in GitLab" goes. */

import type { DefinitionDetail } from '../types/projectPanel.types';

function pathUrl(path: string): string {
  return path.split('/').map(encodeURIComponent).join('/');
}

/** The MR, or the file on the default branch; null when unknown. */
export function openUrl(detail: DefinitionDetail, webUrl: string | null, branch: string | null): string | null {
  if (detail.mr !== null) return detail.mr.url;
  if (webUrl === null || branch === null || detail.state !== 'enabled') return null;
  return `${webUrl}/-/blob/${pathUrl(branch)}/${pathUrl(detail.summary.path)}`;
}
